<template>
    <div
        :class="[
            {
                expanded: !isVerticalMenuCollapsed || (isVerticalMenuCollapsed && isMouseHovered),
            },
            skin === 'semi-dark' ? 'menu-dark' : 'menu-light bg-light',
        ]"
        class="main-menu menu-fixed menu-accordion"
    >
        <!-- main menu header-->
        <div class="navbar-header">
            <slot
                :collapseTogglerIcon="collapseTogglerIcon"
                :toggleCollapsed="toggleCollapsed"
                :toggleVerticalMenuActive="toggleVerticalMenuActive"
                name="header"
            >
                <ul class="nav navbar-nav flex-row d-none d-xl-block">
                    <!-- Toggler Button -->
                    <li class="nav-item nav-toggle">
                        <b-button class="nav-link modern-nav-toggle mt-1" variant="light" @click="toggleCollapsed">
                            <div
                                class="saysimple-icon hamburger d-none d-xl-block collapse-toggle-icon m-50 rounded-circle round-large"
                            />
                        </b-button>
                    </li>
                </ul>
            </slot>
        </div>
        <!-- / main menu header-->

        <!-- main menu content-->

        <perfect-scrollbar
            :settings="perfectScrollbarSettings"
            class="main-menu-content scroll-area"
            tagname="ul"
            @ps-scroll-y="
                (evt) => {
                    shallShadowBottom = evt.srcElement.scrollTop > 0;
                }
            "
        >
            <vertical-nav-menu-items :items="navMenuItems" class="navigation navigation-main" />
        </perfect-scrollbar>
        <!-- /main menu content-->
    </div>
</template>

<script>
import navMenuItems from "@/navigation/vertical";
import { BLink, BImg, BButton } from "bootstrap-vue";
import { provide, computed, ref } from "@vue/composition-api";
import useAppConfig from "@/composables/useAppConfig";
import useVerticalNavMenu from "@core/layouts/layout-vertical/components/vertical-nav-menu/useVerticalNavMenu";
import { $themeConfig } from "@themeConfig";

import VerticalNavMenuItems from "@/layouts/vertical/components/vertical-nav-menu/components/vertical-nav-menu-items/VerticalNavMenuItems.vue";

export default {
    components: {
        VerticalNavMenuItems,
        BLink,
        BImg,
        BButton,
    },
    props: {
        isVerticalMenuActive: {
            type: Boolean,
            required: true,
        },
        toggleVerticalMenuActive: {
            type: Function,
            required: true,
        },
    },
    setup(props) {
        const { isMouseHovered, isVerticalMenuCollapsed, collapseTogglerIcon, toggleCollapsed, updateMouseHovered } =
            useVerticalNavMenu(props);

        const { skin } = useAppConfig();

        // Shadow bottom is UI specific and can be removed by user => It's not in `useVerticalNavMenu`
        const shallShadowBottom = ref(false);

        provide("isMouseHovered", isMouseHovered);

        const perfectScrollbarSettings = {
            maxScrollbarLength: 60,
            wheelPropagation: false,
        };

        const collapseTogglerIconFeather = computed(() =>
            collapseTogglerIcon.value === "unpinned" ? "ellipsis-h" : "ellipsis-h"
        );

        // App Name
        const { appName, appLogoImage } = $themeConfig.app;

        return {
            perfectScrollbarSettings,
            navMenuItems,
            isVerticalMenuCollapsed,
            collapseTogglerIcon,
            toggleCollapsed,
            isMouseHovered,
            updateMouseHovered,
            collapseTogglerIconFeather,

            // Shadow Bottom
            shallShadowBottom,

            // Skin
            skin,

            // App Name
            appName,
            appLogoImage,
        };
    },
};
</script>

<style lang="scss">
@import "~@core/scss/base/core/menu/menu-types/vertical-menu.scss";
</style>
